import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";


const __default__ = {
    name: "EmojiSelectTabIcon"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    icon: {}
  },
  setup(__props: any) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FontAwesomeIcon, {
    icon: __props.icon,
    class: "tab-icon"
  }, null, 8, ["icon"]))
}
}

})